import { render, staticRenderFns } from "./EstateList.vue?vue&type=template&id=42f7535e&"
import script from "./EstateList.vue?vue&type=script&lang=js&"
export * from "./EstateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports